import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";

const FoodPoint = () => {
  return (
    <div className="headerWrap">
      <Link to="/">FoodPoint</Link>
    </div>
  );
};

export default FoodPoint;
